const DEV_FRONTEND_ENTRY_PATH = '/www/index.html';
const DEV_FRONTEND_HOST = 'besafer.development.hispatecanalytics.com';

function isHostedDevelopment() {
  if (typeof window === 'undefined') return false;

  return window.location.hostname === DEV_FRONTEND_HOST;
}

export function getAppEntryPath() {
  if (typeof window === 'undefined') return '/';

  const { pathname } = window.location;

  if (pathname.endsWith(DEV_FRONTEND_ENTRY_PATH)) {
    return pathname;
  }

  // En el entorno DEV publicado, la raiz del dominio pertenece al backend/API.
  // La SPA se sirve desde /www/index.html; cualquier enlace publico generado
  // por el frontend debe conservar esa entrada para evitar respuestas 401.
  if (isHostedDevelopment()) {
    return DEV_FRONTEND_ENTRY_PATH;
  }

  return '/';
}

export function getAppEntryUrl() {
  if (typeof window === 'undefined') return '/';

  return `${window.location.origin}${getAppEntryPath()}`;
}

export function getAppHashUrl(route = '/') {
  const normalizedRoute = route.startsWith('/') ? route : `/${route}`;

  return `${getAppEntryUrl()}#${normalizedRoute}`;
}
